export default __webpack_public_path__ + "static/media/power_of_you.1f807e8f.png";